import { Language } from "@biblioteksentralen/cordata";
import { Portal, Select, VStack, createListCollection } from "@biblioteksentralen/react";
import { useTranslation } from "../../../utils/hooks/useTranslation";
import { formatLanguagesList, getDocumentTypeLabel, getLanguagesSignature } from "@libry-content/integrations";
import { useWorkViewContext } from "../works/WorkViewContextProvider";
import { sift } from "radash";

export const ReservationLanguageMenu = ({ languages }: { languages?: Language[][] }) => {
  const { work, currentVariant, setVariantState } = useWorkViewContext();
  const { t } = useTranslation();
  const currentLanguagesSignature = currentVariant?.variant.signatures.languagesSignature;

  if (!languages) return null;

  const languagesCollection = createListCollection({
    items: languages.map((languageSelection) => ({
      label: formatLanguagesList(languageSelection, { capitalizeFirstLetter: true }),
      value: getLanguagesSignature(languageSelection),
    })),
  });

  return (
    <Select.Root
      size="lg"
      margin={0}
      width="100%"
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
      collection={languagesCollection}
      defaultValue={currentLanguagesSignature ? [currentLanguagesSignature] : undefined}
      onSelect={(item) => setVariantState({ languagesSignature: item.value })}
    >
      <Select.HiddenSelect />
      <Select.Label fontWeight="600">{`${t("Velg språk")}:`}</Select.Label>
      <Select.Control width="100%">
        <Select.Trigger background="white" overflow="hidden" borderRadius="sm" border="1px solid black" paddingY="0">
          <Select.ValueText />
          <Select.Indicator />
        </Select.Trigger>
      </Select.Control>
      <Portal>
        <Select.Positioner>
          <Select.Content>
            {languagesCollection.items.map((languageCollection) => {
              const documentTypes =
                work &&
                sift(work?.getDocumentTypesWithLanguagesSignature(languageCollection.value).map(getDocumentTypeLabel));

              return (
                <Select.Item item={languageCollection} key={languageCollection.value}>
                  <VStack gap="0" alignItems="flex-start">
                    <Select.ItemText fontWeight="semibold" fontSize="md">
                      {languageCollection.label}
                    </Select.ItemText>
                    <Select.ItemText fontSize="sm">{documentTypes?.join(", ")}</Select.ItemText>
                  </VStack>
                  <Select.ItemIndicator />
                </Select.Item>
              );
            })}
          </Select.Content>
        </Select.Positioner>
      </Portal>
    </Select.Root>
  );
};
